import { Edit } from "@mui/icons-material";
import React, { useState, useEffect, useContext } from "react";
import ResizableRect from "react-resizable-rotatable-draggable";
import MyContext from "../../../context/MyContext";
import AuthContext from "../../../context/userAuth.context";

const MultiDragging = ({ Data, setDragProcess, DragProcess }) => {
  const [Positions, setPositions] = useState({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    loaded: false,
  });

  const { EditorZoom, LayersData, setLayersData } = useContext(MyContext);

  const [MainWH, setMainWH] = useState({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
  });

  // useEffect(() => {
  //     return () => {
  //         const newArray = [...LayersData]
  //         for (var i = 0; i < newArray.length; i++) {
  //             newArray[i].InMultiDrag = false
  //         }
  //         setLayersData(newArray);
  //     }
  // }, [])

  function compare(a, b) {
    if (a < b) {
      return -1;
    } else if (a > b) {
      return 1;
    } else {
      return 0;
    }
  }

  const [DraggerData, setDraggerData] = useState([]);

  useEffect(() => {
    if (Data.length != 0) {
      let width = 0;
      let height = 0;
      let top = [];
      let left = [];
      for (const itr of Data) {
        if (width < itr.width + itr.x) {
          width = (itr.width * EditorZoom) / 100 + (itr.x * EditorZoom) / 100;
        }
        if (height < itr.height + itr.y) {
          height = (itr.height * EditorZoom) / 100 + (itr.y * EditorZoom) / 100;
        }
        top.push((itr.y * EditorZoom) / 100);
        left.push((itr.x * EditorZoom) / 100);
      }

      left = left.sort(compare);
      top = top.sort(compare);
      width = width - left[0];
      height = height - top[0];

      let arr = Array.from(Data);

      for (const obj of arr) {
        let leftPercent = Math.round((obj.x * EditorZoom) / 100) - left[0];
        leftPercent = (leftPercent * 100) / width;
        let topPercent = Math.round((obj.y * EditorZoom) / 100) - top[0];
        topPercent = (topPercent * 100) / height;
        obj.topPercent = topPercent;
        obj.leftPercent = leftPercent;
        obj.widthPercent = (((obj.width * EditorZoom) / 100) * 100) / width;
        obj.heightPercent = (((obj.height * EditorZoom) / 100) * 100) / height;
      }

      setDraggerData(arr);

      setPositions({
        width: width,
        height: height,
        top: top[0],
        left: left[0],
        loaded: true,
      });

      setMainWH({ width: width, height: height, top: top[0], left: left[0] });
    }
  }, [Data]);

  const Drag = (deltaX, deltaY) => {
    setPositions({
      ...Positions,
      left: Math.round(Positions.left + deltaX),
      top: Math.round(Positions.top + deltaY),
    });
  };

  const handleResize = ({ top, left, width, height }, isShiftKey, type) => {
    setPositions({
      ...Positions,
      width: Math.round(width),
      height: Math.round(height),
      left: parseInt(Math.round(left)),
      top: parseInt(Math.round(top)),
    });
  };

  const handleUp = () => {
    setDragProcess(false);
  };

  useEffect(() => {
    if (MainWH.width != 0) {
      setTimeout(() => {
        var element = document.getElementsByClassName("single-resizer");

        for (let SubElement of element) {
          if (SubElement.firstChild) {
            if (!SubElement.classList.contains("RectBorder")) {
              //SubElement.style.zIndex = 3000
              SubElement.classList.add("RectBorder");
            }
          }
        }
      }, 300);
    }
  }, [MainWH.width]);

  return (
    <div className="multiDraggerWrapper">
      {Positions.loaded && (
        <>
          <ResizableRect
            rotatable={false}
            top={Positions.top}
            left={Positions.left}
            width={Positions.width}
            height={Positions.height}
            aspectRatio={MainWH.width / MainWH.height}
            zoomable={"nw, ne, se, sw"}
            onResizeStart={() => {
              setDragProcess(true);
            }}
            onResizeEnd={handleUp}
            onResize={handleResize}
            onDrag={Drag}
            onDragEnd={handleUp}
            onDragStart={() => {
              setDragProcess(true);
            }}
          />
          <div
            className="RectBorder"
            style={{
              outline: "2px solid #000",
              zIndex: 499,
              position: "absolute",
              width: Positions.width,
              height: Positions.height,
              top: Positions.top,
              left: Positions.left,
            }}
          >
            {DraggerData.map((value, index) => {
              const zInd = index + 1;

              return (
                <>
                  {value.type === "image" && (
                    <>
                      <ImgDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}

                  {value.type === "text" && (
                    <>
                      <TextDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}

                  {value.type === "basicShape" && (
                    <>
                      <ChangeAbleShapeDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}

                  {value.type === "Shape" && (
                    <>
                      <ShapeDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}

                  {value.type === "Video" && (
                    <>
                      <VideoDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}

                  {value.type === "Props" && (
                    <>
                      <PropDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}

                  {(value.type === "Character" || value.type === "AnimatedText") && (
                    <>
                      <CharacterDrag
                        LayersData={LayersData}
                        setLayersData={setLayersData}
                        zInd={zInd}
                        value={value}
                        EditorZoom={EditorZoom}
                        Positions={Positions}
                        DragProcess={DragProcess}
                        MainWH={MainWH}
                      />
                    </>
                  )}
                </>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
export default MultiDragging;

const ImgDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].height = (newArray[i].height / EditorZoom) * 100;
          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <div className={"DivTag"} draggable={false}>
          <img
            className="ImgTag"
            style={{ transform: value.flip, opacity: value.opacity }}
            draggable={false}
            src={value.ImageSrc}
          />
        </div>
      </div>
    </>
  );
};

const ShapeDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {

  const { authenticationData, Role } = useContext(AuthContext);
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].height = (newArray[i].height / EditorZoom) * 100;
          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <span style={{ width: "100%", height: "100%" }}>
          <img
            className={"ImgTag"}
            draggable={false}
            tabIndex="0"
            src={authenticationData.ApiBaseURL + "/" + value.ShapePath}
            style={{
              transform: value.flip,
              opacity: value.opacity,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: -1,
            }}
          />
        </span>
      </div>
    </>
  );
};

const PropDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {
  const { authenticationData, Role } = useContext(AuthContext);
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].height = (newArray[i].height / EditorZoom) * 100;
          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <div className={"DivTag"} draggable={false}>
          <img
            className="ImgTag"
            style={{ transform: value.flip, opacity: value.opacity }}
            draggable={false}
            src={authenticationData.ApiBaseURL + "/" + value.PropImage}
          />
        </div>
      </div>
    </>
  );
};

const CharacterDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {
  const { authenticationData, Role } = useContext(AuthContext);
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].height = (newArray[i].height / EditorZoom) * 100;
          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <div className={"DivTag"} draggable={false}>
          <img
            className="ImgTag"
            style={{ transform: value.flip, opacity: value.opacity }}
            draggable={false}
            // (Animated text was missing from the group while dragging, and was not moved with it.)
            src={
              !value.ImageSrc
                ? undefined
                : /^(data:|https?:|blob:)/i.test(value.ImageSrc)
                ? value.ImageSrc
                : authenticationData.ApiBaseURL + "/" + value.ImageSrc
            }
          />
        </div>
      </div>
    </>
  );
};

const ChangeAbleShapeDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].height = (newArray[i].height / EditorZoom) * 100;
          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <svg
          width={"100%"}
          height={"100%"}
          preserveAspectRatio="none"
          xmlSpace="preserve"
          x="0px"
          y="0px"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          draggable={false}
          className="basicShapeTag"
          dangerouslySetInnerHTML={{ __html: value.svgContent }}
          style={{
            transform: value.flip,
            opacity: value.opacity,
            zIndex: -1,
          }}
        ></svg>
      </div>
    </>
  );
};

const TextDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {
  //console.log("Selecting text in Text Drag function");
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          //newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          //newArray[i].height = (newArray[i].height / EditorZoom) * 100;

          // newArray[i].Editable = false
          //newArray[i].height = (Positions.height * value.heightPercent) / 100
          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <div style={{ textAlign: value.Align }} className="textDivSize">
          <span
            id={value.TextId}
            style={{
              textDecoration: value.textDec,
              fontStyle: value.Fontstyle,
              fontSize: Math.round((value.fontSize * EditorZoom) / 100) + "px",
              fontWeight: value.fontWeight,
              opacity: value.opacity,
              color: value.textColor,
              overflowWrap: "break-word",
              fontFamily: value.googleFontSetting.fontFamily,
              //maxWidth: value.widthPercent + '%',
            }}
            className="textInput"
            spellCheck="false"
            dangerouslySetInnerHTML={{ __html: value.text }}
          />
        </div>
      </div>
    </>
  );
};

const VideoDrag = ({
  zInd,
  value,
  LayersData,
  setLayersData,
  DragProcess,
  Positions,
  EditorZoom,
}) => {
  useEffect(() => {
    if (!DragProcess) {
      var newArray = [...LayersData];
      for (var i = 0; i < newArray.length; i++) {
        if (newArray[i].key === value.key) {
          newArray[i].x =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].x = (newArray[i].x / EditorZoom) * 100;
          newArray[i].y =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].y = (newArray[i].y / EditorZoom) * 100;
          newArray[i].originalX =
            Positions.left + (Positions.width * value.leftPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalX = (newArray[i].originalX / EditorZoom) * 100;
          newArray[i].originalY =
            Positions.top + (Positions.height * value.topPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].originalY = (newArray[i].originalY / EditorZoom) * 100;
          newArray[i].width = (Positions.width * value.widthPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].width = (newArray[i].width / EditorZoom) * 100;
          newArray[i].height = (Positions.height * value.heightPercent) / 100;
          //fix for multi drag while canvas zoom.
          newArray[i].height = (newArray[i].height / EditorZoom) * 100;

          break;
        }
      }
      setLayersData(newArray);
    }
  }, [DragProcess]);

  return (
    <>
      <div
        style={{
          width: value.widthPercent + "%",
          height: value.heightPercent + "%",
          zIndex: zInd,
          transform: `rotate(${value.rotateAngle}deg)`,
          left: value.leftPercent + "%",
          top: value.topPercent + "%",
          position: "absolute",
        }}
      >
        <div className={"DivTag"} draggable={false}>
          <img
            className="ImgTag"
            style={{ transform: value.flip, opacity: value.opacity }}
            draggable={false}
            src={value.ImageSrc}
          />
        </div>
      </div>
    </>
  );
};
